import React, { useCallback } from 'react';
import { Trans } from '@lingui/react';

import { Flex } from '@rover/kibble/core';
import { AccordionItem } from '@rover/react-lib/src/components/lists/Accordion';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import type { CountryFooterLink } from '@rover/types/src/CountryFooterLink';

import {
  HomePageFooterAccordionCollapsed,
  HomePageFooterAccordionExpanded,
} from './analyticsEvents';
import FooterLinkList from './FooterLinkList';

export type Props = {
  countryFooterLinks: CountryFooterLink[];
};

const CountriesLinks = ({ countryFooterLinks }: Props): JSX.Element => {
  const handleAccordionToggle = useCallback((isOpen: boolean) => {
    const eventProperties = { dropDownName: `Pet care all over the world` };
    const EventCtor = isOpen ? HomePageFooterAccordionExpanded : HomePageFooterAccordionCollapsed;
    emitAnalyticsEvent(new EventCtor(eventProperties));
  }, []);

  return (
    <AccordionItem
      itemHeading={
        <>
          <Trans id="Pet care all over the world" />
          <span aria-hidden="true"> 🌎</span>
        </>
      }
      itemBody={
        <Flex flexDirection={['column', 'column', 'row']}>
          <FooterLinkList linkList={countryFooterLinks} />
        </Flex>
      }
      onToggle={handleAccordionToggle}
      testID="footer-accordion-countries-links"
    />
  );
};

export default CountriesLinks;
